import { formatMoney } from "./g-utils";

class DeliveryProgressBar extends HTMLElement {
  static observedAttributes = ["data-free-delivery-amount", "data-amount-left"];

  constructor() {
    super();
    this.freeDeliveryAmountValueEls = this.querySelectorAll('[data-free-delivery-amount-value]')
    this.amountLeftValueEls = this.querySelectorAll('[data-amount-left-value]');
  }

  connectedCallback() {
    document.documentElement.addEventListener('cart:rerendered', this._rerender.bind(this));
  }

  attributeChangedCallback(name, oldValue, newValue) {
    switch(name) {
      case "data-free-delivery-amount":
        this.freeDeliveryAmountValueEls.forEach(item => item.textContent = formatMoney(newValue));
        break;
      case "data-amount-left":
        if(newValue == "0") {
          this.classList.add('js-reached');
        } else {
          this.amountLeftValueEls.forEach(item => item.textContent = formatMoney(newValue));
          this.classList.remove('js-reached');
        }
        break;
    }
  }

  _rerender(event) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        let amount = 0;

        const newBooks = cart.items.filter(item => item.title.toUpperCase().includes(this.dataset.newBookTitle.toUpperCase()));
        const usedBooks = cart.items.filter(item => !item.title.toUpperCase().includes(this.dataset.newBookTitle.toUpperCase()));

        if(newBooks.length > 0) {
          amount = newBooks.reduce((acc, item) => acc + item.final_price * item.quantity, 0);
        } else {
          amount = usedBooks.reduce((acc, item) => acc + item.final_price * item.quantity, 0);
        }

        this.freeDeliveryAmount = newBooks.length > 0 ? this.dataset.newBooksAmount : this.dataset.usedBooksAmount;
        this.amountLeft = this.freeDeliveryAmount - amount;
        this.style.setProperty("--progress", (this.freeDeliveryAmount - this.amountLeft) / this.freeDeliveryAmount * 100 + "%");
      })
      .catch(error => {
        console.error('Error fetching the cart:', error);
      });
  }

  set freeDeliveryAmount(value) {
    this.dataset.freeDeliveryAmount = value;
  }

  get freeDeliveryAmount() {
    return Number.parseInt(this.dataset.freeDeliveryAmount);
  }

  set amountLeft(value) {
    this.dataset.amountLeft = Math.max(value, 0);
  }

  get amountLeft() {
    return Number.parseInt(this.dataset.amountLeft);
  }
}

window.customElements.define('delivery-progress-bar', DeliveryProgressBar);